/**
 * title Cookies Notice
 * description Shows and hides the site's cookies notice.
 */
function cookiesNotice() {
  const cookieNoticeElement = document.querySelector('[data-js="cookies-notice"]')

  if (document.body.contains(cookieNoticeElement)) {
    const cookieNoticeElementHeight = cookieNoticeElement.scrollHeight
    const cookieAcceptButton = document.querySelector('[data-js="cookies-accept"]')
    const cookieRejectButton = document.querySelector('[data-js="cookies-reject"]')

    function setCookie(cname, cvalue, exdays) {
      const d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      const expires = "expires=" + d.toUTCString()
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
    }

    function deleteAllCookies() {
      var cookies = document.cookie.split(";")

      cookies.forEach(function (cookie) {
        var eqPos = cookie.indexOf("=")
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        setCookie(name, "", -1)
      })
    }

    function acceptCookies(reload) {
      setCookie("cookies-accepted", true, 365)
      localStorage.setItem("cookies", "true")
      cookieNoticeElement.style.transform = `translate(0, ${cookieNoticeElementHeight}px)`
      document.body.classList.remove("global-wrapper--cookies")

      if (reload) {
        window.location.reload()
      }
    }

    function rejectCookies(reload) {
      localStorage.setItem("cookies", "false")
      deleteAllCookies()
      cookieNoticeElement.style.transform = `translate(0, ${cookieNoticeElementHeight}px)`
      document.body.classList.add("global-wrapper--cookies")

      if (reload) {
        window.location.reload()
      }
    }

    if (document.body.contains(cookieNoticeElement)) {
      const cookieStorage = localStorage.getItem("cookies")

      if (cookieStorage === "false") {
        localStorage.setItem("cookies", "false")
        rejectCookies()
      } else if (cookieStorage === "true") {
        cookieNoticeElement.style.display = "none"
        acceptCookies()
      }

      if (document.body.contains(cookieAcceptButton)) {
        cookieAcceptButton.addEventListener("click", function (e) {
          e.preventDefault
          acceptCookies(true)
        })
      }

      if (document.body.contains(cookieRejectButton)) {
        cookieRejectButton.addEventListener("click", function (e) {
          e.preventDefault
          rejectCookies(false)
        })
      }
    }
  }
}

export default cookiesNotice
